import { API_URL, CLOUD_FUNCTION } from "./constants";

export async function request<TResponse>(
  url: string,
  config: RequestInit = {}
): Promise<TResponse> {
  return fetch(url, config)
    .then((response) => response.json())
    .then((data) => data as TResponse)
    .catch((data) => data);
}

export const api = {
  get: <TResponse>(url: string, config: RequestInit) =>
    request<TResponse>(url, config),

  post: <TResponse>(url: string, body: any) =>
    request<TResponse>(url, { method: "POST", body: JSON.stringify(body) }),
};

export const now = () => {
  return (
    new Date().toISOString().slice(0, 10) +
    " " +
    new Date().toLocaleTimeString("en-GB")
  );
};
export const getToken = () => {
  let token = localStorage.getItem("token_aduana");
  if (token != null) {
    token = JSON.parse(token);
  }
  return token;
};

export const setToken = (token: any) => {
  localStorage.setItem("token_aduana", JSON.stringify(token));
  return token;
};

export const removeToken = () => {
  localStorage.removeItem("token_aduana");
};

export const CONSTRUCTION = (self: any) => {
  self.$f7?.toast
    .create({
      text: "🚧 &nbsp;&nbsp;En Construcción&nbsp;&nbsp; 🚧",
      position: "center",
      closeTimeout: 1500,
    })
    .open();
};

export const SCAN_PRODUCTS = async (link: string, idCompetitor: number) => {
  const data = (await api.post(API_URL + CLOUD_FUNCTION + "getCompetitor", {
    link,
  })) as any;

  // PRODUCTS
  let results = data.split('"results":[')[3].split(',"search_filter":{')[0];
  results = "[" + results;
  const page = JSON.parse(results);

  const book: any[] = [];
  page.map((item: any) => {
    item.category = "SIN_CATEGORIA";
    if (
      item.tags.indexOf("fulfillment") > -1 &&
      item.tags.indexOf("free_shipping") === -1
    ) {
      item.category = "FULL_SIN_ENVIO";
    } else if (
      item.tags.indexOf("fulfillment") > -1 &&
      item.tags.indexOf("free_shipping") > -1
    ) {
      item.category = "FULL_CON_ENVIO";
    } else if (
      item.tags.indexOf("fulfillment") === -1 &&
      item.tags.indexOf("free_shipping") === -1
    ) {
      item.category = "SIN_FULL_SIN_ENVIO";
    } else if (
      item.tags.indexOf("fulfillment") === -1 &&
      item.tags.indexOf("free_shipping") > -1
    ) {
      item.category = "SIN_FULL_CON_ENVIO";
    }

    const row = {
      id: item.id,
      name: item.title,
      price: item.price.amount,
      category: item.category,
      inventory: item.available_quantity,
      data: JSON.stringify(item),
      id_competitor: idCompetitor,
      status: 1,
    };
    book.push(row);
  });

  return book;
};



// WEBPACK FOOTER //
// ./src/utils/utils.ts